import { useWindowResize } from '@utils/domUtils'

import { Box } from '@shared/components/Box'

import styles from './CampaignProgressBar.module.scss'

type Tiers = 1 | 2 | 3

const TIER_TO_PROGRESS_WIDTH_MAP: Record<Tiers, number> = {
  1: 0,
  2: 50,
  3: 100,
}

const TOTAL_STEPS = 12
const MIN_PROGRESS = 0
const MAX_PROGRESS = 100

const getProgressPercent = (value: number): number => {
  if (!Number.isFinite(value)) return MIN_PROGRESS
  return Math.min(MAX_PROGRESS, Math.max(MIN_PROGRESS, value))
}

const isTier = (value: number | undefined): value is Tiers => {
  return value === 1 || value === 2 || value === 3
}

export const CampaignProgressBar: React.FC<{
  monthlyTradedVolume?: number
  currentTier?: number
}> = ({ monthlyTradedVolume = 0, currentTier }) => {
  const isMobile = useWindowResize()

  const calculateProgressWidth = () => {
    if (isTier(currentTier)) {
      return TIER_TO_PROGRESS_WIDTH_MAP[currentTier]
    }

    return getProgressPercent((monthlyTradedVolume / TOTAL_STEPS) * 100)
  }

  return (
    <Box
      flex
      gap='x4'
      minHeight='16px'
      radius='x32'
      overflowX='hidden'
      overflowY='hidden'
      alignSelf='stretch'
      position='relative'
      maxWidth={isMobile ? '290px' : '320px'}
    >
      {Array.from({ length: 55 }).map((_, idx) => (
        <Box key={idx} className={styles.rectangle} />
      ))}
      <Box
        radius='x32'
        bg='surface-primary-med-em'
        minWidth='14px'
        minHeight='14px'
        position='absolute'
        style={{ width: `${calculateProgressWidth()}%` }}
      ></Box>
    </Box>
  )
}
